import React, { Component } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { compose } from 'redux'
import { connect } from 'react-redux'
import gql from 'graphql-tag'
import uniqBy from 'lodash.uniqby'
import pickBy from 'lodash.pickby'

import withQuery from 'containers/withQuery'
import FillVideo from 'ui/components/generic/FillVideo'

const entry = keyframes`
  0% {
    opacity: 0;
    transform: scale(1.1, 1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
`

const Wrapper = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow: hidden;
`

const Bg = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: ${(props) => props.z};

  animation: ${entry} 1s both;

  ${(props) =>
    props.background.type === 'image' &&
    css`
    background-image: url('${props.background.image}');
    background-size: cover;
    background-position: center;
  `}

  ${(props) =>
    props.background.type === 'color' &&
    css`
      background-color: ${(props) => props.background.color};
    `}

  &:after {
    display: block;
    content: '';
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    background-color: rgba(0, 0, 0, 0.6);
    pointer-events: none;
    opacity: ${(props) => (props.overlay ? 1 : 0)};
    transition: opacity 500ms;
  }
`

class Background extends Component {
  getBackground(background, index) {
    const defaultBackground = {
      ...this.props.defaultBackground,
    }

    // Transform defaultBackground
    if (defaultBackground.image) {
      defaultBackground.image = defaultBackground.image.sourceUrl
    }

    if (defaultBackground.video) {
      defaultBackground.video = defaultBackground.video.mediaItemUrl
    }

    const targetBackground =
      background.type === 'default' ? defaultBackground : background

    if (!targetBackground) return null

    let { type, video, overlay } = targetBackground

    return (
      <Bg
        z={index}
        background={targetBackground}
        overlay={overlay}
        key={JSON.stringify(background)}
      >
        {type === 'video' && (
          <FillVideo src={video} playsInline muted autoPlay loop />
        )}
      </Bg>
    )
  }

  render() {
    const { backgrounds } = this.props

    return (
      <Wrapper>
        {/* remove falsy values of each item and then remove duplicates */}
        {uniqBy(backgrounds.map(pickBy), (bg) =>
          JSON.stringify(bg)
        ).map((bg, index) => this.getBackground(bg, index))}
      </Wrapper>
    )
  }
}

export default compose(
  connect((state) => ({
    backgrounds: state.background.backgrounds,
  })),
  withQuery(
    () => gql`
      {
        optionsMisc {
          defaultBackground {
            type
            image {
              sourceUrl
            }
            video {
              mediaItemUrl
            }
            color
            overlay
          }
        }
      }
    `,
    'defaultBackground',
    (data, key) => data.optionsMisc.defaultBackground
  )
)(Background)



// WEBPACK FOOTER //
// ./src/ui/components/Background.js